import { BasicButtonType } from 'models/Common/buttonTypes';
import styled from 'styled-components';
import { BackgroundColor, InverseColor, PrimaryColor, OpacityColor, WarningColor } from 'styles/Global/colorSemantic';
import { Border } from 'styles/Global/objectStyles';
import { Body5Medium } from 'styles/Global/typography';

export const PositiveButton = ({ children, $width, onClick, disabled, $height, $gap, $type }: BasicButtonType) => {
    return (
        <PositiveButtonCss $width={$width} onClick={onClick} disabled={disabled} $height={$height} $gap={$gap} $type={$type}>
            {children}
        </PositiveButtonCss>
    );
};
export const NegativeButton = ({ children, $width, onClick, disabled, $height, $gap, $type }: BasicButtonType) => {
    return (
        <NegativeButtonCss $width={$width} onClick={onClick} disabled={disabled} $height={$height} $gap={$gap} $type={$type}>
            {children}
        </NegativeButtonCss>
    );
};

const VariantsBasicButtonCss = styled(Body5Medium)<BasicButtonType>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => props.$width ?? '80px'};
    height: ${(props) => props.$height ?? '36px'};
    padding: 8px 16px;
    border-radius: 4px;
    line-height: normal;
    transition: all 0.2s ease;
`;

const PositiveButtonCss = styled(VariantsBasicButtonCss)<BasicButtonType>`
    color: ${PrimaryColor.color_primary_strong};
    border: ${Border.border_1} solid ${PrimaryColor.color_primary_strong};
    background-color: ${BackgroundColor.color_background_white};
    &:hover {
        border: none;
        background-color: ${PrimaryColor.color_primary_normal};
        color: ${InverseColor.color_inverse_white};
    }
    &:active {
        border: none;
        background-color: ${PrimaryColor.color_primary_heavy};
        color: ${InverseColor.color_inverse_white};
    }
    &:focus {
        border: none;
        background-color: ${PrimaryColor.color_primary_heavy};
        color: ${InverseColor.color_inverse_white};
    }
    &:disabled {
        background-color: ${BackgroundColor.color_background_primary_disabled};
        color: ${OpacityColor.color_opacity_white_80};
        border: none;
        cursor: not-allowed;
    }
`;

const NegativeButtonCss = styled(VariantsBasicButtonCss)<BasicButtonType>`
    color: ${WarningColor.color_warning_normal};
    border: ${Border.border_1} solid ${WarningColor.color_warning_normal};
    background-color: ${BackgroundColor.color_background_white};
    &:hover {
        border: none;
        background-color: ${WarningColor.color_warning_normal};
        color: ${InverseColor.color_inverse_white};
    }
    &:active {
        border: none;
        background-color: ${WarningColor.color_warning_normal_press};
        color: ${InverseColor.color_inverse_white};
    }
    &:focus {
        border: none;
        background-color: ${WarningColor.color_warning_normal_press};
        color: ${InverseColor.color_inverse_white};
    }
    &:disabled {
        background-color: ${BackgroundColor.color_background_primary_disabled};
        color: ${OpacityColor.color_opacity_white_80};
        border: none;
        cursor: not-allowed;
    }
`;
